import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModalComponent } from '@common2/components/modal/modal.component';
import { CommonToastService } from '@common2/services/toast.service';
import { CompanyCertificatesProvider, ContentProvider } from '@lighty';
import { StorageService, TranslateService } from '@services';
import { CookieService } from 'ngx-cookie-service';
import { take } from 'rxjs';
import { MediaProvider } from '@lighty';
import { environment } from '@env/environment';

@Component({
    selector: 'app-banners-info',
    templateUrl: './banners-info.component.html',
    styleUrls: ['./banners-info.component.scss'],
})
export class WatchBannersInfoComponent implements OnInit {
    @ViewChild('modalAdd') modalAdd: CommonModalComponent;
    @ViewChild('modalDelete') modalDelete: CommonModalComponent;
    @ViewChild('modalContentSelection') modalContentSelection: CommonModalComponent;
    @ViewChild('modalImageRecommendations') modalImageRecommendations: CommonModalComponent;
    public banners: any[] = [];
    public newBanner: any = {
        imageUrl: '',
        providerName: '',
        name: '',
        title: '',
        detail: '',
        actionUrl: '',
        actionType: '',
        startAt: '',
        endAt: '',
        description: '',
        // duration: 0,
        contentType: '',
        contentId: 0,
        buttonLabel: ''
    };
    public isLoading: boolean = false;
    public isLoadingTable: boolean = true;
    public hasError: boolean = false;
    public errorMsg: string = '';
    public isEdit: boolean = false;
    public currentEditBannerId: number = -1;
    public currentDeleteBannerId: number = -1;
    public company: any;
    public experience: any;
    public recommendedContentByCompany: any[] = [];
    public searchTerm: string = '';
    public contentTypes: any[] = [
        { value: 'external_content', label: this.translateService.instant('words.external_content') },
        { value: 'course_instance', label: this.translateService.instant('api.content-type.course') },
        { value: 'journey', label: this.translateService.instant('words.journey') },
        { value: 'other', label: this.translateService.instant('words.other') },
    ];
    public bannerTimers: any[] = [
        { value: 5, label: `5 ${this.translateService.instant('words.seconds')}` },
        { value: 10, label: `10 ${this.translateService.instant('words.seconds')}` },
        { value: 15, label: `15 ${this.translateService.instant('words.seconds')}` },
        { value: 30, label: `30 ${this.translateService.instant('words.seconds')}` },

    ];
    public selectedContentType: string = '';
    public currentBannerTimer: number = 5;
    public selectedContent: any = null;

    copied: boolean = false;
    public isLoadingImage: boolean = false;

    constructor(
        private companyCertificatesProvider: CompanyCertificatesProvider,
        private cookieService: CookieService,
        private toastService: CommonToastService,
        private translateService: TranslateService,
        private contentProvider: ContentProvider,
        private storageService: StorageService,
        private mediaProvider: MediaProvider,
        private cdr: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
        this.company = this.storageService.get('company');
        this.experience = this.storageService.get('currentExperience');
        this.getBanners();
        this.getBannerTime();
    }


    public openModalAdd(banner?: any): void {
        this.resetForm();
        if (banner) {
            this.newBanner = { ...banner };
            this.currentEditBannerId = banner.id;
            this.isEdit = true;
        }
        this.modalAdd.onOpen();
    }

    copyLink(url: string): void {
        const textarea = document.createElement('textarea');
        textarea.value = url;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    }

    public openEdit(banner: any): void {
        this.resetForm();
        this.newBanner = { ...banner };
        this.selectedContentType = this.getLabelByValue(banner.contentType);
        if (this.newBanner.startAt !== null && this.newBanner.startAt !== '')
            this.newBanner.startAt = this.formatDate(new Date(this.newBanner.startAt));
        if (this.newBanner.endAt !== null && this.newBanner.endAt !== '')
            this.newBanner.endAt = this.formatDate(new Date(this.newBanner.endAt));
        this.currentEditBannerId = banner.id;
        this.isEdit = true;
        this.modalAdd.onOpen();
    }

    formatDate(date: Date): string {
        return date.toISOString().split('T')[0]; // YYYY-MM-DD
    }

    public createBanner(): void {
        // Validar campos básicos
        if (!this.newBanner.imageUrl || this.newBanner.imageUrl.trim() === '') {
            this.toastService.onError(this.translateService.instant('validation.image-required') || 'La imagen es requerida');
            return;
        }

        if (!this.newBanner.contentType || this.newBanner.contentType.trim() === '') {
            this.toastService.onError(this.translateService.instant('validation.content-type-required') || 'El tipo de contenido es requerido');
            return;
        }

        if (this.newBanner.contentType === 'other') {
            if (!this.newBanner.actionUrl || this.newBanner.actionUrl.trim() === '') {
                this.toastService.onError(this.translateService.instant('validation.action-url-required'));
                return;
            }
            this.newBanner.actionType = '_blank';
            this.newBanner.buttonLabel = this.newBanner.buttonLabel !== '' ? this.newBanner.buttonLabel : 'informative.banner.button.other';
        } else if (this.newBanner.contentType === 'external_content') {
            if (!this.selectedContent || !this.selectedContent.contentId) {
                this.toastService.onError('Debes seleccionar un contenido externo');
                return;
            }
            this.newBanner.buttonLabel = 'informative.banner.button.course';
            this.newBanner.actionType = '_self';
            this.newBanner.actionUrl = `/learn/${this.company.slug}/detail/external-content/${this.selectedContent.providerSlug}/${this.newBanner.contentId}/presentation`;
        } else if (this.newBanner.contentType === 'course_instance') {
            if (!this.selectedContent || !this.selectedContent.contentId) {
                this.toastService.onError('Debes seleccionar un curso');
                return;
            }
            this.newBanner.buttonLabel = 'informative.banner.button.course';
            this.newBanner.actionType = '_self';
            this.newBanner.actionUrl = `/learn/${this.company.slug}/detail/instance/${this.newBanner.contentId}/presentation`;
        } else if (this.newBanner.contentType === 'journey') {
            if (!this.selectedContent || !this.selectedContent.contentId) {
                this.toastService.onError('Debes seleccionar una ruta de aprendizaje');
                return;
            }
            this.newBanner.buttonLabel = 'informative.banner.button.traject';
            this.newBanner.actionType = '_self';
            this.newBanner.actionUrl = `/learn/${this.company.slug}/detail/${this.newBanner.contentType}/${this.newBanner.contentId}/presentation`;
        }

        // Crear objeto limpio solo con los campos que el backend espera
        const bannerData = {
            name: this.newBanner.name,
            detail: this.newBanner.detail,
            title: this.newBanner.title,
            description: this.newBanner.description,
            imageUrl: this.newBanner.imageUrl,
            providerName: this.newBanner.providerName,
            contentType: this.newBanner.contentType,
            contentId: this.newBanner.contentId,
            actionUrl: this.newBanner.actionUrl,
            actionType: this.newBanner.actionType,
            buttonLabel: this.newBanner.buttonLabel,
            startAt: this.newBanner.startAt,
            endAt: this.newBanner.endAt
        };

        console.log('=== CREATING BANNER ===');
        console.log('Banner data limpio:', bannerData);
        console.log('Company ID:', this.company.id);
        console.log('Experience ID:', this.experience.id);
        console.log('======================');

        this.isLoading = true;
        this.cdr.markForCheck();

        this.contentProvider.createBannerInfo(this.company.id, this.experience.id, bannerData).pipe(take(1)).subscribe(
            (response) => {
                console.log('✅ BANNER CREADO EXITOSAMENTE:', response);
                this.toastService.onSuccess(this.translateService.instant('toast.saved'));
                this.modalAdd.onClose();
                this.getBanners();
                this.resetForm();
                this.onCloseModalContentSelection();
                this.isLoading = false;
                this.cdr.markForCheck();
            },
            (error) => {
                console.log('❌ ERROR AL CREAR BANNER:', error);
                this.isLoading = false;
                this.cdr.markForCheck();
                this.handleError(error);
            }
        );
    }

    public updateBanner(): void {
        const updatedBanner = { ...this.newBanner, id: this.currentEditBannerId };
        this.contentProvider
            .updateBannerInfo(this.company.id, this.experience.id, updatedBanner, this.currentEditBannerId)
            .pipe(take(1))
            .subscribe(
                () => {
                    this.toastService.onSuccess(this.translateService.instant('toast.saved'));
                    this.onCloseModalContentSelection();
                    this.modalAdd.onClose();
                    this.getBanners();
                    this.resetForm();
                },
                (error) => this.handleError(error)
            );
    }

    public deleteBanner(): void {
        this.contentProvider.deleteBannerInfo(this.company.id, this.experience.id, this.currentDeleteBannerId).pipe(take(1)).subscribe(() => {
            this.toastService.onSuccess(this.translateService.instant('toast.deleted'));
            this.modalDelete.onClose();
            this.getBanners();
        }, (error) => {
            this.handleError(error);
            this.modalDelete.onClose();
        })
    }

    public openModalDelete(id: number): void {
        this.currentDeleteBannerId = id;
        this.modalDelete.onOpen();
    }

    public toggleBannerStatus(id: number): void {
        const banner = this.banners.find(b => b.id === id);
        banner.estatus = !banner.estatus;
        this.companyCertificatesProvider
            .toggleTemplateStatus(id)
            .pipe(take(1))
            .subscribe(
                () => this.toastService.onSuccess(this.translateService.instant('toast.updated')),
                (error) => this.handleError(error)
            );
    }

    public isFormValid(): boolean {
        const hasBasicFields = (
            this.newBanner.name &&
            this.newBanner.providerName &&
            this.newBanner.title &&
            this.newBanner.detail &&
            this.newBanner.description &&
            this.newBanner.imageUrl &&
            this.newBanner.contentType
        );

        if (!hasBasicFields) {
            return false;
        }

        // Validaciones específicas por tipo de contenido
        if (this.newBanner.contentType === 'other') {
            return this.newBanner.actionUrl && this.newBanner.actionUrl.trim() !== '';
        } else if (['journey', 'course_instance', 'external_content'].includes(this.newBanner.contentType)) {
            // Para estos tipos, debe haber contenido seleccionado (contentId > 0)
            return this.newBanner.contentId && this.newBanner.contentId > 0;
        }

        return true;
    }

    private resetForm(): void {
        this.newBanner = {
            imageUrl: '',
            providerName: '',
            name: '',
            title: '',
            detail: '',
            actionUrl: '',
            actionType: '',
            startAt: '',
            endAt: '',
            description: '',
            duration: 0,
            contentType: '',
            contentId: 0,
            buttonLabel: ''
        };
        this.currentEditBannerId = -1;
        this.selectedContentType = '';
        this.hasError = false;
        this.errorMsg = '';
    }

    private handleError(error: any): void {
        this.hasError = true;
        const msg = error.error?.message;
        this.errorMsg = typeof msg === 'string' ? msg : 'Error desconocido';
        this.toastService.onError(this.translateService.instant(this.errorMsg));
    }

    public getBanners(): void {
        this.contentProvider.getBanners(this.company.id, this.experience.id).pipe(take(1)).subscribe((data) => {
            this.banners = data.data;
            console.log('Banners:', this.banners);
            this.isLoadingTable = false;
        });
    }

    public getRecommendedContentByCompany(): void {
        const params = {
            title: this.searchTerm,
            type: this.newBanner.contentType,
        };
        this.isLoading = true;
        this.recommendedContentByCompany = [];
        this.contentProvider.getRecommendedCompanyContents(this.company.id, 1, params).pipe(take(1)).subscribe((data) => {
            this.recommendedContentByCompany = data.data;
            console.log('Banners: recommendedContentByCompany', this.recommendedContentByCompany);
            this.isLoadingTable = false;
            this.isLoading = false;
        });
    }

    public openModalContentSelection(): void {
        this.getRecommendedContentByCompany();
        this.modalContentSelection.onOpen();
    }

    public onPickBannerElement(banner: any): void {
        this.modalContentSelection.onClose();
        console.log('Banner seleccionado:', banner);
        this.selectedContent = banner;
        // Usar providerName, name, title, o el nombre de la experiencia como fallback
        this.newBanner.providerName = banner.providerName || banner.name || banner.title || this.experience.name || '';
        this.newBanner.contentType = banner.contentType;
        this.newBanner.contentId = banner.contentType === 'course_instance' ? banner.templateId : banner.contentId;

        // La imagen puede venir en distintas rutas según el tipo de contenido.
        // Para course_instance suele venir vacía en `picture`/`data.picture` y
        // termina como "https://api.myskillcamp.com/api/stockage/" (base sin filename).
        // Buscamos en varios campos y descartamos URLs que terminen en "/stockage/" o "/stockage".
        const candidates = [
            banner?.data?.picture,
            banner?.picture,
            banner?.data?.cover,
            banner?.cover,
            banner?.data?.thumbnail,
            banner?.thumbnail,
            banner?.data?.template?.picture,
            banner?.template?.picture,
        ];
        const isValidPicture = (url: string) => {
            if (!url || typeof url !== 'string' || url.trim() === '') return false;
            const clean = url.split('?')[0].replace(/\/$/, '');
            return !/\/stockage$/i.test(clean) && /\/[^/]+\.[a-z0-9]{2,5}$/i.test(clean) || !/\/stockage$/i.test(clean) && clean.includes('/stockage/');
        };
        const rawPicture = candidates.find(isValidPicture);

        if (rawPicture) {
            this.newBanner.imageUrl = `${rawPicture}${rawPicture.includes('?') ? '' : '?size=512'}`;
        } else {
            const fallbackId = (banner?.contentId || banner?.data?.id || 0) % 7;
            this.newBanner.imageUrl = `https://static.myskillcamp.com/lxp/images/logo-empty-state-${fallbackId}.webp`;
        }
        console.log('[onPickBannerElement] imageUrl resuelto:', this.newBanner.imageUrl, '— candidates:', candidates);
        this.newBanner.title = banner.title;
        this.newBanner.description = banner.description;
        if (banner.contentType === 'external_content') {
            this.newBanner.actionUrl = `/learn/${this.company.slug}/detail/external-content/${banner.providerSlug}/${banner.contentId}/presentation`;
        } else if (banner.contentType === 'course_instance') {
            this.newBanner.actionUrl = `/learn/${this.company.slug}/detail/instance/${banner.templateId}/presentation`;
        } else {
            this.newBanner.actionUrl = `/learn/${this.company.slug}/detail/${banner.contentType}/${banner.contentId}/presentation`;
        }
        this.newBanner.actionType = '_self';
        // Limpiar estado del modal de búsqueda
        this.recommendedContentByCompany = [];
        this.searchTerm = '';
        console.log('Contenido seleccionado completo:', this.newBanner);
        console.log('Form válido después de seleccionar contenido:', this.isFormValid());
        this.cdr.markForCheck();
    }

    public onSelectOption(event: any): void {
        this.newBanner.contentType = event.value;
        this.selectedContentType = event.label;
        if (this.newBanner.contentType === 'other') {
            this.newBanner.providerName = this.experience.name;
        }
        // No limpiar providerName para otros tipos - se poblará cuando selecciones contenido
        console.log('Tipo de acción seleccionado:', event.value);
    }

    public onCloseModalContentSelection(): void {
        this.modalContentSelection.onClose();
        this.recommendedContentByCompany = [];
        this.searchTerm = '';
    }

    public onFileSelected(event: any): void {
        this.isLoadingImage = true;
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                // Guardar data URL temporalmente para preview
                this.newBanner.imageUrl = e.target.result;
                this.mediaProvider.uploadMedia(file).pipe(take(1)).subscribe(
                    (response) => {
                        console.log('Archivo subido - Response completo:', response);
                        this.isLoadingImage = false;

                        // Construir la URL correcta de la imagen
                        // response.url puede ser: 'image://nombre.png' o 'image/nombre.png' o directamente la URL
                        let imageUrl = response.url;
                        let apiUrl = environment.envVar.API_URL

                        if (imageUrl.includes('image://') || imageUrl.includes('image/') || !imageUrl.includes('http')) {
                            const fileName = imageUrl.replace('image://', '').replace('image/', '');
                            //img visible para other en cursos
                            imageUrl = `${apiUrl}/stockage/image/${fileName}?size=1024`;
                        }

                        this.newBanner.imageUrl = imageUrl;
                        console.log('ImageUrl actualizada:', this.newBanner.imageUrl);
                        this.toastService.onSuccess(this.translateService.instant('toast.file_uploaded'));
                        this.cdr.markForCheck();
                        console.log('Form válido después de imagen:', this.isFormValid());
                    },
                    (error) => {
                        this.hasError = true;
                        this.isLoadingImage = false;
                        this.errorMsg = error.error?.message || 'Error al subir el archivo';
                        this.toastService.onError(this.translateService.instant(this.errorMsg));
                        this.cdr.markForCheck();
                    }
                );
            };
            reader.readAsDataURL(file);
        }
    }

    public onSelectOptiontTimerBanner(event: any): void {
        this.currentBannerTimer = event.value;
        this.updateBannerTime();
    }

    public getBannerTime(): void {
        this.contentProvider.getBannerDuration(this.company.id, this.experience.id).pipe(take(1)).subscribe((data) => {
            if (data) {
                this.currentBannerTimer = data.bannerTransitionDuration / 1000
            } else {
                this.currentBannerTimer = 5;
            }
        }, (error) => {
            this.hasError = true;
            this.errorMsg = error.error?.message || 'Error al obtener el tiempo del banner';
            this.toastService.onError(this.translateService.instant(this.errorMsg));
        });
    }

    public updateBannerTime(): void {
        const bannerTimeData = {
            banner_transition_duration: this.currentBannerTimer * 1000,
        };
        this.contentProvider.updateBannerDuration(this.company.id, this.experience.id, bannerTimeData).pipe(take(1)).subscribe(
            (response) => {
                this.toastService.onSuccess(this.translateService.instant('toast.saved'));
            },
            (error) => this.handleError(error)
        );
    }

    public getLabelByValue(value: string): string {
        const type = this.contentTypes.find(item => item.value === value);
        return type ? type.label : value;
    }

    public convertToISO(dateString: string): string {
        const isoDate = dateString.replace(' ', 'T') + '.000Z';
        return isoDate;
    }

    public onCloseModalAdd(): void {
        this.modalAdd.onClose();
        this.resetForm();
        this.isEdit = false;
        this.currentEditBannerId = -1;
        this.selectedContentType = '';
    }

    public openImageRecommendationsModal(): void {
        this.modalImageRecommendations.onOpen();
    }
}